<template>
  <alert
    v-if="nextEnvironment"
    :message="`The following changes will not be published to ${nextEnvironment}.`"
    type="warning"
    inline
  />
</template>
        
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import alert from "@/qux-common/qux22/components/molecules/alert";

export default {
  name: "EnvironmentSaveWarning",
  components: {
    alert,
  },
  computed: {
    ...mapGetters({
      nextEnvironment: "getNextEnvironment",
    }),
  },
};
</script>
        
<style lang="scss" scoped>
.v-alert {
  margin-top: $qvo-spacing-16;
}
</style>